import React from 'react';
import './RichContent.scss';

function RichContent({ contentHtml = null, isShowRichContent = false }) {
  return (
    <>
      {isShowRichContent && contentHtml !== null && (
        <div dangerouslySetInnerHTML={{ __html: contentHtml }} className="rich-content__wrapper" />
      )}
    </>
  );
}

export default RichContent;
